module.exports = __webpack_public_path__ + "6c8e9f9c89a4c62d1b11366c2e14dd3c.MP3";